import { render, staticRenderFns } from "./OutOfWarrantyModal.vue?vue&type=template&id=5d64f8f6&scoped=true"
import script from "./OutOfWarrantyModal.vue?vue&type=script&lang=js"
export * from "./OutOfWarrantyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d64f8f6",
  null
  
)

export default component.exports